export default __webpack_public_path__ + "static/media/table-arrow.af66ff33.svg";